module.exports["caseSensitivePathsWebpackPlugin"] = function() { return require("case-sensitive-paths-webpack-plugin"); };
module.exports["globToRegexp"] = function() { return require("glob-to-regexp"); };
module.exports["hashIndex"] = function() { return require("hash-index"); };
module.exports["inspectpack"] = function() { return require("inspectpack/plugin"); };
module.exports["isGlob"] = function() { return require("is-glob"); };
module.exports["webpackChain"] = function() { return require("webpack-chain-5"); };
module.exports["webpackMerge"] = function() { return require("webpack-merge"); };